import React, { createContext, ReactElement, useContext } from "react";
import {
  CMP_DEFAULT_ORGANIZATION_NOUN,
  CmpOrganizationNoun,
  getCmpOrganizationNoun,
} from "../utils/cmpOrganizationNoun";

// LoggedInApp provides the signed-in chamber name from its existing getUser
// result. Components outside the provider (public pages, isolated tests) get
// the default "chamber" noun without an extra query.
const CmpOrganizationNounContext = createContext<CmpOrganizationNoun>(
  CMP_DEFAULT_ORGANIZATION_NOUN
);

export const CmpOrganizationNounProvider = ({
  chamberName,
  children,
}: {
  chamberName?: string | null;
  children: React.ReactNode;
}): ReactElement => {
  // getCmpOrganizationNoun returns shared constants, so the value is stable.
  return (
    <CmpOrganizationNounContext.Provider value={getCmpOrganizationNoun(chamberName)}>
      {children}
    </CmpOrganizationNounContext.Provider>
  );
};

export const useCmpOrganizationNoun = (): CmpOrganizationNoun =>
  useContext(CmpOrganizationNounContext);
